<template lang="pug">
.k-booking-card-base
  v-row(align="center" justify="space-between")
    slot
    .hidden-xs-only
      v-badge(
        v-if="notificationCount"
        right
        top
      )
        template(v-slot:badge) {{ notificationCount }}
        k-icon(color="brand-warm-grey" size="19" @click.prevent="$refs.bookingChat.openChat()").flip-horizontal chat
    .hidden-xs-only
      k-dropdown(v-if="!hideMenu")
        nuxt-link(:to="'/my-kintell/bookings/' + booking.id" :key="booking.id").unstyled--link.paragraph--small Go to details page
        template( v-if="!booking.isAdvisorInitiatedAndPendingApproval")
          v-divider.my-5
          slot(name="dropdown")
          a(v-if="authenticatedUser.hasBookings" @click="$refs.bookingChat.openChat()").paragraph--small.pr-2 {{ notificationCount ? 'Your messages' : 'Send a message' }}
          k-chip(
            v-if="notificationCount"
            color="brand-pink"
            text-color="white"
            x-small
          ).k-booking-card-base__notification {{ notificationCount }}
    .hidden-sm-and-up.align-self-start
      k-chip(
        v-if="notificationCount"
        color="brand-pink"
        text-color="white"
        x-small
      ).k-booking-card-base__notification {{ notificationCount }}
  k-booking-chat(
    v-if="authenticatedUser.hasBookings && !booking.isAdvisorInitiatedAndPendingApproval"
    :other-user="otherUser"
    :booking="booking"
    @notification="(e) => notificationCount = e"
    ref="bookingChat"
    hide-button
  )

</template>

<script>
import { UsesAuthenticatedUser } from '@/mixins'
export default {
  mixins: [
    UsesAuthenticatedUser
  ],
  props: {
    /**
     * The booking. Should be an instance of a Booking model.
     */
    booking: {
      type: Object,
      required: true,
    },
    otherUser: {
      type: Object,
      required: true,
    },
    hideMenu: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      notificationCount: 0
    }
  },
}
</script>

<style lang="scss" scoped>
.k-booking-card-base {
  &__notification {
    padding: 0 9px !important;
    height: 18px !important;
  }
}
</style>
